import Service from "@/helpers/py-service";
const state = {
  loading: false,
  meta: {},
  list: [],
  childTenantList: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_CHILD_TENANT_LIST(state, payload) {
    state.childTenantList = payload;
  },

  ADD_LIST(state, payload) {
    state.list.unshift(payload);
  },
  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return Service.get("core/tenant-to-tenant", params)
      .then((data) => {
        if (params?.page) {
          store.commit("SET_META", data.body);
          store.commit("SET_LIST", data.body.data);
        } else {
          store.commit("SET_LIST", data.body);
        }
      })
      .finally(() => (store.state.loading = false));
  },
  childTenantList: (store, params) => {
    store.state.loading = true;
    return Service.get(`core/child-tenant`, params)
      .then((data) => {
        store.commit("SET_CHILD_TENANT_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  add: (store, params) => {
    return Service.post(`core/tenant-to-tenant`, params).then((data) => {
      store.commit("ADD_LIST", data.body);
      return data.body;
    });
  },

  destroy: (store, params) => {
    return Service.destroy(`core/tenant-to-tenant/${params.id}`, params).then(
      () => {
        store.commit("DELETE_LIST", params);
      }
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getChildTenantList(state) {
    return state.childTenantList;
  },
  //
};

const tenantRelationship = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default tenantRelationship;
